/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function PenNib(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232.00586,92.68994l-68.68652-68.6875a16.02162,16.02162,0,0,0-22.62793.001L115.57349,49.12158l-58.053,21.77a16.045,16.045,0,0,0-10.165,12.35108L26.58887,207.83984a4,4,0,0,0,6.77417,3.48584l55.08423-55.08545a32.0378,32.0378,0,1,1,11.311,11.31543L44.667,222.64893a4,4,0,0,0,3.48609,6.77392l124.61352-20.769a16.0433,16.0433,0,0,0,12.35059-10.16406l21.77-58.05371,25.11767-25.11817a15.99888,15.99888,0,0,0,.001-22.62793Zm-32,31.99951-68.686-68.686,20.686-20.68653,68.68555,68.68653Z" />
      <Circle cx={116.00586} cy={140.00342} r={16} />
    </Svg>
  );
}

export default PenNib;
